import { SettingsSort, StarLarge, StarLargeFilled } from '@griply/assets';
import { Skeleton } from '@mui/material';
import { useLocalizedLifeAreaById } from 'features/life-areas';
import { useIsFavorite, useToggleFavorite } from 'features/user';
import React, { useRef } from 'react';
import { useParams } from 'react-router';
import { LifeAreaContextMenu } from 'shared/components/connected/life-area-context-menu';
import { Colors, IconButton, Sizes } from 'shared/components/ui/icon-button';
import { useOpenMenu } from 'shared/hooks/use-open-menu';
import { FavoriteType } from 'shared/types/user-settings';

import * as Styled from './page-top-bar.style';

export const LoadingInteractions: React.FC = () => (
  <Skeleton animation="wave" width="6.4rem" height="3.2rem" />
);

export const Interactions: React.FC = () => {
  const interactionsRef = useRef<HTMLDivElement>(null);

  const { id } = useParams();
  const lifeArea = useLocalizedLifeAreaById(id);
  const isFavorite = useIsFavorite(id);

  const { menuOpen, openMenu, closeMenu } = useOpenMenu();
  const toggleFavorite = useToggleFavorite();

  const onFavorite = () => {
    !!lifeArea && toggleFavorite(lifeArea.id, FavoriteType.LifeArea);
  };

  return (
    <Styled.Interactions ref={interactionsRef}>
      <Styled.FavoriteButtonContainer>
        <IconButton
          icon={isFavorite ? StarLargeFilled : StarLarge}
          onClick={onFavorite}
          color={isFavorite ? Colors.Warning : Colors.Inherit}
          strokeWidth={2}
          preventDrag
        />
      </Styled.FavoriteButtonContainer>

      <IconButton
        icon={SettingsSort}
        size={Sizes.Medium}
        strokeWidth={2}
        onClick={openMenu}
        preventDrag
      />
      {menuOpen && !!lifeArea && (
        <LifeAreaContextMenu
          lifeArea={lifeArea}
          onClose={closeMenu}
          position="bottom-end"
          referenceElement={interactionsRef}
        />
      )}
    </Styled.Interactions>
  );
};
